import { memo, useContext } from 'react';
import { TranscriptContext } from '../../contexts/TranscriptContext';
import { NOT_TRANSCRIBED_LIMIT_REACHED } from '../../types/TranscriptionRequestStatus';
import { TranscriptionStatusEmptyState } from './transcriptEmptyStates/TranscriptionStatusEmptyStates';
import { TranscriptSettingsDisabledAdminEmptyState, TranscriptSettingsDisabledNonAdminEmptyState } from './transcriptEmptyStates/TranscriptSettingsDisabledEmptyState';
import { TranscriptionStatusGenericEmptyState } from './transcriptEmptyStates/TranscriptionStatusGenericEmptyState';
import { NoUserAssignedThirdPartyEmptyState, NoUserAssignedZoomEmptyState } from './transcriptEmptyStates/NoUserAssignedTranscriptEmptyState';
import { NoTranscriptionScopeEmptyState } from './transcriptEmptyStates/NoTranscriptionScopeEmptyState';
import { TranscriptPQL } from './transcriptEmptyStates/TranscriptPQL';
import { EMPTY_STATE_TRANSCRIPTION_STATUS } from '../../constants/EmptyTranscriptRequestStatus';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { MediaElementContext } from '../../media-player/context/MediaElementContext';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const CALL_SOURCE_ZOOM = 'ZOOM';
const MemoizedTranscriptEmptyStateWrapper = /*#__PURE__*/memo(props => {
  const {
    children,
    hasRecording
  } = props;
  const {
    callSource,
    assignedUser,
    isTranscriptionAdmin,
    hasTranscriptionFeature,
    callOwnerHasTranscriptionScope,
    transcriptionStatus,
    isTranscriptUsageLimitReached,
    isTranscriptSettingLoading,
    isTranscriptSettingEnabled,
    highlightedOrFullTranscript
  } = useContext(TranscriptContext);
  if (highlightedOrFullTranscript.length > 0) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  } else if (!hasTranscriptionFeature) {
    return /*#__PURE__*/_jsx(TranscriptPQL, {});
  } else if (isTranscriptSettingLoading && isTranscriptionAdmin) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-icon-name": "loading-spinner",
      "data-test-id": "loading-spinner",
      minHeight: 450,
      layout: "centered",
      showLabel: true,
      size: "medium"
    });
  } else if (!isTranscriptSettingEnabled) {
    if (isTranscriptionAdmin) {
      return /*#__PURE__*/_jsx(TranscriptSettingsDisabledAdminEmptyState, {});
    } else {
      return /*#__PURE__*/_jsx(TranscriptSettingsDisabledNonAdminEmptyState, {});
    }
  } else if (EMPTY_STATE_TRANSCRIPTION_STATUS.includes(transcriptionStatus) && transcriptionStatus !== NOT_TRANSCRIBED_LIMIT_REACHED && hasRecording) {
    return /*#__PURE__*/_jsx(TranscriptionStatusEmptyState, {
      transcriptionStatus: transcriptionStatus
    });
  } else if (transcriptionStatus === NOT_TRANSCRIBED_LIMIT_REACHED) {
    return /*#__PURE__*/_jsx(TranscriptionStatusEmptyState, {
      transcriptionStatus: NOT_TRANSCRIBED_LIMIT_REACHED,
      isTranscriptionAdmin: isTranscriptionAdmin,
      isUsageLimitReached: isTranscriptUsageLimitReached
    });
  } else if (!callOwnerHasTranscriptionScope) {
    return /*#__PURE__*/_jsx(NoTranscriptionScopeEmptyState, {
      isTranscriptionAdmin: isTranscriptionAdmin
    });
  } else if (!assignedUser) {
    if (callSource === CALL_SOURCE_ZOOM) {
      return /*#__PURE__*/_jsx(NoUserAssignedZoomEmptyState, {});
    }
    return /*#__PURE__*/_jsx(NoUserAssignedThirdPartyEmptyState, {
      callSource: callSource
    });
  }
  return /*#__PURE__*/_jsx(TranscriptionStatusGenericEmptyState, {
    hasRecording: hasRecording,
    callSource: callSource
  });
});
export const TranscriptEmptyStateWrapper = props => {
  const {
    recordingUrl
  } = useContext(MediaElementContext);
  return /*#__PURE__*/_jsx(MemoizedTranscriptEmptyStateWrapper, Object.assign({}, props, {
    hasRecording: !!recordingUrl
  }));
};